import { DrawnMark, EmptyMark, OMark, XMark } from './symbols';
import type { Theme } from './types';

export const classicTheme: Theme = {
  id: 'classic',
  name: 'Classic',

  symbols: { X: XMark, O: OMark, empty: EmptyMark, drawn: DrawnMark },

  classes: {
    page: 'flex flex-col items-center min-h-screen bg-gray-50 p-4 sm:p-8',
    title: 'text-3xl sm:text-4xl font-bold text-gray-800 mb-4',

    metaBoard:
      'grid grid-cols-3 gap-1.5 sm:gap-2 border-4 border-gray-800 p-2 sm:p-3 bg-white shadow-lg rounded-lg',
    miniIdle: 'border-gray-500 bg-gray-50',
    miniActive: 'border-blue-500 bg-blue-50 ring-2 ring-blue-300',
    miniWonX: 'border-blue-600 bg-blue-100',
    miniWonO: 'border-red-600 bg-red-100',
    miniDrawn: 'border-gray-500 bg-gray-200',
    miniOverlay: 'absolute inset-0 flex items-center justify-center bg-white/75 rounded',

    cellBase:
      'w-7 h-7 sm:w-8 sm:h-8 border border-gray-400 flex items-center justify-center transition-colors',
    cellPlayable: 'bg-white hover:bg-blue-200 cursor-pointer',
    cellBlocked: 'bg-gray-100 cursor-not-allowed',
    cellResolved: 'bg-gray-200 cursor-not-allowed',

    turnX: 'text-blue-600',
    turnO: 'text-red-600',
    statusWin: 'text-2xl font-bold text-green-600',
    statusDraw: 'text-2xl font-bold text-orange-600',
    statusHint: 'text-sm text-gray-600',

    button:
      'px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold',
    buttonDisabled: 'px-5 py-2 bg-gray-300 text-gray-500 rounded-lg font-semibold cursor-not-allowed',

    panel: 'flex flex-wrap items-end justify-center gap-4 mb-5',
    label: 'block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1',
    select:
      'border border-gray-300 rounded-md px-3 py-2 bg-white text-gray-800 text-sm ' +
      'focus:outline-none focus:ring-2 focus:ring-blue-400',
    thinking: 'text-sm text-gray-500 italic',
  },
};
